import React, { useEffect } from 'react';
import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AnswersTable from './AnswersTable';

function Answers() {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Grid gap={2} display="flex" flexDirection="column">
      <Typography variant="h6" color="primary">
        {t('clientProgress.answers')}
      </Typography>
      <Grid>
        <AnswersTable />
      </Grid>
    </Grid>
  );
}

export default Answers;
